import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameMasking'
})
export class NameMaskingPipe implements PipeTransform {

  transform(name: string, ...args: unknown[]): unknown {
    try {
      let originVal = name
      if(name) {
        if (name.length === 1) {
            return name;
        } else if (name.length === 2) {
            return name.slice(0, 1) + '*';
        } else {
            return name.slice(0, 1) + '*'.repeat(name.length - 2) + name.slice(-1)
        }
      }
      
    } catch (error) {
      console.log(error)
      name = ""
    }
    return name;
  }

}
